import { useFonts } from "expo-font";

import AzbukaPro from "../assets/fonts/AzbukaPro-Bold.otf";
import SharpGroteskBook20 from "../assets/fonts/SharpGroteskBook20Regular.ttf";
import SharpGroteskMedium20 from "../assets/fonts/SharpGroteskMedium20Regular.ttf";

export const FONTS = {
  SharpGroteskBook20,
  SharpGroteskMedium20,
  "AzbukaPro-Bold": AzbukaPro,
};

export const useFontsLoad = () => {
  const [loaded, fontError] = useFonts({
    SharpGroteskBook20: require("../assets/fonts/SharpGroteskBook20Regular.ttf"),
    SharpGroteskMedium20: require("../assets/fonts/SharpGroteskMedium20Regular.ttf"),
    "AzbukaPro-Bold": require("../assets/fonts/AzbukaPro-Bold.otf"),
  });

  return loaded || !!fontError;
};
